import React from 'react';
import styled from 'styled-components';

// Components
import ErrorHandler from '../../../_molecules/ErrorHandler';
import TrackPageView from '@tracking/TrackPageView';
import SectionHeader from '../../../_molecules/SectionHeader';
import RetailersFeatured from '../../../_organisms/RetailersFeatured';
import SearchRetailersAll from '../../../searches/SearchRetailersAll';
import HeroWithCTA from '@molecules/HeroWithCTA';
import LoadingArea from '@molecules/LoadingArea';
import { DivWithShadowMediumUp, H4, SectionWrapperInner, SectionWrapperOuter } from '@styled';

// Functionality
import useViewerEvents from '@hooks/useViewerEvents';
import useDocumentTitle from '@hooks/useDocumentTitle';

// Images
import RetailersLandingHeader from '../../../../../images/RetailersLandingHeader.png';

const SectionContainer = styled.div`
    margin-bottom: 40px;
`;

const RetailersLandingPage = () => {
    const { data: viewerEvents } = useViewerEvents({ futureOnly: true });
    const { documentTitle } = useDocumentTitle('My ICSC Retailers');

    if (!viewerEvents) {
        return <LoadingArea />;
    }

    return (
        <ErrorHandler>
            <TrackPageView>
                <SectionWrapperOuter>
                    <SectionWrapperInner className="fade-in-fast">
                        <SectionHeader
                            title={documentTitle}
                            tutorialLabel="How to use the Networking Platform"
                            tutorialUrl="https://view.ceros.com/icsc/icsc-networking-platfrom/p/1"
                        />

                        {/*
                    <SectionContainer>
                        <HeroWithCTA
                            text="Retailer Call to Action"
                            ctaText="Call to Action"
                            ctaAction={() => alert('Retailer CTA')}
                            imageSrc={RetailersLandingHeader}
                        />
                    </SectionContainer>
                    */}

                        {viewerEvents.length > 0 && (
                            <SectionContainer style={{ marginTop: '40px' }}>
                                <RetailersFeatured />
                            </SectionContainer>
                        )}

                        <div>
                            <H4 className="mb-1.5rem">Retailer Directory</H4>

                            <DivWithShadowMediumUp>
                                <SearchRetailersAll showPagingToolbar showSearchBox showSearchOptions />
                            </DivWithShadowMediumUp>
                        </div>
                    </SectionWrapperInner>
                </SectionWrapperOuter>
            </TrackPageView>
        </ErrorHandler>
    );
};

RetailersLandingPage.propTypes = {
    //
};

export default RetailersLandingPage;
